import { CreateUpdateMooringComponent, MooringComponent } from './MooringComponent';

class BaseMooringFleetAnchorLine {
  MoorlogNo!: string;
  AnalysisNo!: string;
  DimForce?: number;
  IsAccident!: boolean;

  MblRopes?: number;
  MblSinkRopes?: number;
  MblStraps?: number;

  MblChainShackleConnectionPlates?: number;
  MblAnchoring?: number;
  MblUsedChainRopeWithKnot?: number;
  BottomAnchoringUplift?: number;
  DepthAtAnchoringPoint?: number;

  CornerNo!: number;

  Slope?: number;

  StartPositionLat!: string;
  StartPositionLong!: string;

  StopPositionLat!: string;
  StopPositionLong!: string;

  HoldingPowerAnchoring?: number;
  LengthOfBottomRope!: number;
  LengthOfRope!: number;
  TotalLength!: number;
}

export class UpdateMooringFleetAnchorLineDto extends BaseMooringFleetAnchorLine {
  Id!: number;
  MoorlogNo!: string;
  Components!: CreateUpdateMooringComponent[];
}

export class AddMooringFleetAnchorLineDto {
  MoorlogNo!: string;
  AnalysisNo!: string;
}

export class MooringFleetAnchorLine extends BaseMooringFleetAnchorLine {
  Id!: number;
  Components!: MooringComponent[];
  HasUnresolvedComments!: boolean;
  HasUnresolvedComponentComments!: boolean;
  HasComments!: boolean;
}

export class MooringProductionFleetAnchorLineSlotDto {
  ComponentId?: number;
  ArticleProductId?: number;
  ProductName!: string;
  Quantity?: number;
  ComponentCount!: number;
}

export class MooringProductionFleetAnchorLineDto {
  Id!: number;
  MooringId!: number;
  MoorlogNo!: string;
  AnalysisNo!: string;
  DepthAtAnchoringPoint!: number | null;
  MblRopes!: number | null;
  MblSinkRopes!: number | null;
  MblStraps!: number | null;
  MblChainShackleConnectionPlates!: number | null;
  MblAnchoring!: number | null;
  HoldingPowerAnchoring!: number | null;
  BottomAnchoringUplift!: number | null;
  AnchorType!: string;
  AnchoringUtilizationFactor!: number | null;
  ShackleForAnchoring!: string;
  BottomChainDimension!: string;
  BottomChainUtilizationFactor!: number | null;
  LengthOfBottomRope!: number;
  ShackleForSpliceBottomChain!: string;
  TonsForCounterWeightUpLift!: number | null;
  ShacklesForCounterWeight!: number;
  TrianglePlateForCounterWeight!: number;
  MeterChainFromAnchoringToCounterWeight!: number | null;
  MeterChainForRope!: number | null;
  ThrawlBalls!: number | null;
  ShackleForRope!: string;
  Thimble!: string;
  LengthOfRope!: number;
  RopeDimension!: string;
  RopeType!: string;
  RopeMbl!: number;
  RopeUtilizationFactor!: number | null;
  AnchorLineStrap!: string;
  AnchorLineStrapUtilizationFactor!: number | null;
  LengthAnchorLineStrap!: string;
  DimForce!: number | null;
  AnchorSlot!: MooringProductionFleetAnchorLineSlotDto;
  AnchoringShackleSlot!: MooringProductionFleetAnchorLineSlotDto;
  BottomChainSlot!: MooringProductionFleetAnchorLineSlotDto;
  SpliceBottomChainShackleSlot!: MooringProductionFleetAnchorLineSlotDto;
  RopeShackleSlot!: MooringProductionFleetAnchorLineSlotDto;
  ThimbleSlot!: MooringProductionFleetAnchorLineSlotDto;
  RopeSlot!: MooringProductionFleetAnchorLineSlotDto;
  AnchorLineStrapSlot!: MooringProductionFleetAnchorLineSlotDto;
}

export class UpdateMooringProductionFleetAnchorLineDto extends MooringProductionFleetAnchorLineDto {}
